module.exports = __webpack_public_path__ + "img/the-well-logo.83331a2c.png";